import moment from 'moment'
moment.locale('en', {
	weekdays: [
		"周日", "周一", "周二", "周三", "周四", "周五", "周六"
	]
});
export default {
	moment,
	getCharsLen(str) {
		var len = 0;
		for (var i = 0; i < str.length; i++) {
			var c = str.charCodeAt(i);
			//单字节加1
			if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
				len++;
			} else {
				len += 2;
			}
		}
		return len;
	},
	isEmptyObject(obj) {
		var name;
		for (name in obj) {
			return false;
		}
		return true;
	},
	getType(data) {
		let type = typeof data;
		if (data && type == "object" && data.length && !isNaN(data.length) && typeof data.splice === 'function') {
			return "array"
		}
		return type;
	},
	deepClone(data) {
		var type = this.getType(data);
		var obj;
		if (type === 'array') {
			obj = [];
		} else if (type === 'object') {
			obj = {};
		} else {
			//不再具有下一层次
			return data;
		}
		if (type === 'array') {
			for (var i = 0, len = data.length; i < len; i++) {
				obj.push(this.deepClone(data[i]));
			}
		} else if (type === 'object') {
			for (var key in data) {
				obj[key] = this.deepClone(data[key]);
			}
		}
		return obj;
	},
	toThousands(num) {
		if (num == 0) {
			return 0;
		}
		if (!num) {
			return "";
		}
		if ((typeof num != "number" && Number(num) == NaN)) {
			return num;
		}
		var numInt = Math.floor(num);
		var floatNum = "";
		if (num.toString().split(".").length > 1) {
			// 有小数的默认2位
			floatNum = num.toString().split(".")[1];
			floatNum = Math.round(Number("0." + floatNum) * 100);
			floatNum = floatNum >= 10 ? "." + floatNum : ".0" + floatNum;
		}
		return (numInt || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + floatNum;
	},
	formatHour(minutes) {
		var d = Math.floor(minutes / (24 * 60));
		var h = Math.floor(minutes % (24 * 60) / 60);
		var m = minutes % (24 * 60) % 60;
		if (d == 0) {
			return h + "小时" + m + "分钟";
		}
		return d + "天" + h + "小时" + m + "分钟";
	},
	getScrollTop() {
		var scrollPos;
		if (window.pageYOffset) {
			scrollPos = window.pageYOffset;
		} else if (document.compatMode && document.compatMode != 'BackCompat') {
			scrollPos = document.documentElement.scrollTop;
		} else if (document.body) {
			scrollPos = document.body.scrollTop;
		}
		return scrollPos;
	},

	debounce(fn, delay) {
		var delay = delay || 200;
		var timer;
		return function() {
			var th = this;
			var args = arguments;
			if (timer) {
				clearTimeout(timer);
			}
			timer = setTimeout(function() {
				timer = null;
				fn.apply(th, args);
			}, delay);
		};
	},
	throttle(fn, interval) {
		var last;
		var timer;
		var interval = interval || 200;
		return function() {
			var th = this;
			var args = arguments;
			var now = +new Date();
			if (last && now - last < interval) {
				clearTimeout(timer);
				timer = setTimeout(function() {
					last = now;
					fn.apply(th, args);
				}, interval);
			} else {
				last = now;
				fn.apply(th, args);
			}
		}
	}
}
